import { render, staticRenderFns } from "./PrecentileIndicator.vue?vue&type=template&id=14c77026"
import script from "./PrecentileIndicator.vue?vue&type=script&lang=js"
export * from "./PrecentileIndicator.vue?vue&type=script&lang=js"
import style0 from "./PrecentileIndicator.vue?vue&type=style&index=0&id=14c77026&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports